var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":`${_vm.$t('task.priority.text')}: ${_vm.text}`}},[_c('i',{staticClass:"font-size-24 align-middle mr-2",class:_vm.icon}),(!_vm.onlyIcon)?_c('span',{staticClass:"bold-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }